import { db } from "../firebaseConfig";
import { collection, addDoc, updateDoc, deleteDoc, doc, serverTimestamp, orderBy, query, getDocs, where, limit, startAfter } from "firebase/firestore";

export async function addCategory(data) {
  const payload = {
    name: data.name,
    slug: (data.slug || data.name || "").toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,''),
    parentId: data.parentId || null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };
  const ref = await addDoc(collection(db, "categories"), payload);
  return ref.id;
}

export async function updateCategory(id, patch) {
  await updateDoc(doc(db, "categories", id), { ...patch, updatedAt: serverTimestamp() });
}

export async function deleteCategory(id) {
  await deleteDoc(doc(db, "categories", id));
}

export async function listCategories({ parentId = null, pageSize = 50, cursor = null } = {}) {
  let q;
  if (parentId !== null) {
    q = query(collection(db, "categories"), where("parentId", "==", parentId), orderBy("createdAt", "desc"), limit(pageSize));
  } else {
    q = query(collection(db, "categories"), orderBy("createdAt", "desc"), limit(pageSize));
  }
  if (cursor) q = query(q, startAfter(cursor));
  const snap = await getDocs(q);
  const items = snap.docs.map(d => ({ id: d.id, ...d.data() }));
  const nextCursor = snap.docs.at(-1) || null;
  return { items, nextCursor };
}
